var _a;
import { ModeName } from "./mode-names";
var wishListMessages = {
    title: "wishlist.title",
    subtitle: "wishlist.subtitle"
};
var sharedBackInStockMessages = {
    title: "backInStock.title",
    subtitle: "backInStock.subtitle"
};
var priceMarkdownMessages = {
    title: "priceMarkdown.title",
    subtitle: "priceMarkdown.subtitle"
};
var bagCheckout = {
    title: "checkout.title",
    subtitle: "checkout.subtitle"
};
var detectAccount = {
    title: "detectAccount.title",
    subtitle: "detectAccount.subtitle"
};
var orderConfirmation = {
    title: "orderConfirmation.title",
    subtitle: "orderConfirmation.subtitle"
};
export var messages = (_a = {},
    _a[ModeName.WISHLIST_BAG] = wishListMessages,
    _a[ModeName.WISHLIST_CDP] = wishListMessages,
    _a[ModeName.WISHLIST_LANDING] = wishListMessages,
    _a[ModeName.WISHLIST_PDP] = wishListMessages,
    _a[ModeName.BIS_PDP] = sharedBackInStockMessages,
    _a[ModeName.BIS_MY_BAG] = sharedBackInStockMessages,
    _a[ModeName.WE_MADE_TOO_MUCH_MARKDOWN_PDP] = priceMarkdownMessages,
    _a[ModeName.SFL_BAG] = wishListMessages,
    _a[ModeName.LOGIN_CHECKOUT_MODAL] = bagCheckout,
    _a[ModeName.CHECKOUT_STEP_ZERO] = bagCheckout,
    _a[ModeName.DETECT_ACCOUNT] = detectAccount,
    _a[ModeName.DETECT_ACCOUNT_OCP] = orderConfirmation,
    _a);
